import { useFeatureFlag } from 'configcat-react';

import { ExclamationMarkHexagonIcon } from '@grupoboticario/flora-react-icons';

import { NOTIFICATION_MULTBRAND_LOGIN } from 'core';
import config from 'config';

import Styles from './Login.components.styles';
import { ResponsiveFloraTypography } from 'ui/components';

export const NotificationMultbrand = () => {
  const defaultNotification = '{"message": "", "flag": false}';
  const { value: isNotificationMultbrand } = useFeatureFlag(
    NOTIFICATION_MULTBRAND_LOGIN,
    defaultNotification,
  );
  const isBot = config.app.short === 'bot';

  const { message, flag: isFlagEnable } =
    JSON.parse(isNotificationMultbrand || '{}') || defaultNotification;

  if (isBot && isFlagEnable) {
    return (
      <Styles.Tag>
        <ExclamationMarkHexagonIcon size={24} />
        <ResponsiveFloraTypography
          fontSize="exceptionsAuxiliar"
          fontWeight="medium"
          aria-label={`Aviso ${message}`}
        >
          {message}
        </ResponsiveFloraTypography>
      </Styles.Tag>
    );
  }
  return <></>;
};
